/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Agen_NInputs */

const en_mk_tut_agen_n = /** @type {(inputs: Mk_Tut_Agen_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the result is off, write a comment with the correction and mention the agent with @ — it will redo the work with your note. Any correction that is really a rule belongs in **Company memory**, two chapters further down.`)
};

const id_mk_tut_agen_n = /** @type {(inputs: Mk_Tut_Agen_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau hasilnya belum pas, tulis komentar berisi koreksi dan sebut agennya dengan @ — ia akan mengerjakan ulang dengan catatan Anda. Jangan lupa menyimpan koreksi yang bersifat aturan ke **Memori perusahaan**, yang dibahas dua bab setelah ini.`)
};

/**
* | output |
* | --- |
* | "If the result is off, write a comment with the correction and mention the agent with @ — it will redo the work with your note. Any correction that is really ..." |
*
* @param {Mk_Tut_Agen_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_agen_n = /** @type {((inputs?: Mk_Tut_Agen_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Agen_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_agen_n(inputs)
	return en_mk_tut_agen_n(inputs)
});